import React from "react";
import "./Product.scss";
import PrimaryButton from "../../../../common/primaryButton";
import Tag from "../../../../components/tags/Tag";
import { earth } from "../../../../assets/images/images";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "../../../../common/ScrollToTop";

const Product = () => {
  const navigate = useNavigate();
  const navigateToSignup = () => {
    navigate("/signup");
    scrollToTop();
  };

  return (
    <section className="section product-section" id="productId">
      <div className="container">
        <div className="product-content">
          <div className="text-content" data-aos="fade-right">
            <Tag
              dot
              text="Product"
              className="stroke"
              style={{ marginInline: "0" }}
            />
            <h2>Get chips in just minutes anywhere at any time!</h2>
            <p className="text">
              You can get access to up to 10 million USD in casino chips 24
              hours a day, 7 days a week in just minutes at participating
              casinos around the world!
            </p>
            <PrimaryButton
              primaryBtnText="Join Bitline"
              className="secondary"
              handleClick={navigateToSignup}
              primaryBtnIcon={
                <svg
                  width="7"
                  height="10"
                  viewBox="0 0 7 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.43994 0.760254L5.43994 4.76025L1.43994 8.76025"
                    stroke="black"
                    strokeWidth="1.36"
                  />
                </svg>
              }
            />
            <div className="bottom-content">
              <ul>
                <li>
                  <h4>Step 1: Bitline account</h4>
                  <p>
                    Transfer eligible assets into your Bitline custody account.
                  </p>
                </li>
                <li>
                  <h4>Step 2: Initiate Transaction</h4>
                  <p>
                    Choose Casino where you would like to create a transaction.
                    (More than 10,000 Casinos supported).
                  </p>
                </li>
              </ul>
              <ul>
                <li>
                  <h4>Step 3: Configure amount</h4>
                  <p>Choose a transaction amount (Up to $10,000,000 USD).</p>
                </li>
                <li>
                  <h4>Step 4: Transaction approval</h4>
                  <p>
                    The Casino is notified of your visit and, if it is your
                    first transaction, initiates the transaction approval
                    process.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="right-content" data-aos="fade-left">
            <div className="upper-card">
              <div className="header">
                <div className="heading">
                  <div className="coin-img">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 17.2686V22.2842L18.1406 13.6123L12 17.2686Z"
                        fill="#3C3C3B"
                      />
                      <path
                        d="M12 2.22168L18.1406 12.4404L12 16.0967L5.8125 12.4404"
                        fill="#343434"
                      />
                      <path
                        d="M12 2.22168V9.62793L5.8125 12.4404M5.8125 13.6123L12 17.2686V22.2842"
                        fill="#8C8C8C"
                      />
                      <path
                        d="M12 9.62793V16.0967L18.1406 12.4404"
                        fill="#141414"
                      />
                      <path
                        d="M5.8125 12.4404L12 9.62793V16.0967"
                        fill="#393939"
                      />
                    </svg>
                  </div>
                  <h4>Ethereum</h4>
                </div>
                <div className="info">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 8.2998V6.2998M6 4.2998H6.005M11 6.2998C11 9.06123 8.76142 11.2998 6 11.2998C3.23858 11.2998 1 9.06123 1 6.2998C1 3.53838 3.23858 1.2998 6 1.2998C8.76142 1.2998 11 3.53838 11 6.2998Z"
                      stroke="black"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="bottom">
                <div className="tag">ETH</div>
                <h5>
                  100.02 ETH <span>equals to $235,776.00</span>
                </h5>
              </div>
            </div>
            <div className="send-eth">
              <div className="send-btn" onClick={navigateToSignup}>
                <p>Send ETH</p>
                <span>100 ETH</span>
              </div>
              <div className="curr-icon">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 17.2686V22.2842L18.1406 13.6123L12 17.2686Z"
                    fill="#3C3C3B"
                  />
                  <path
                    d="M12 2.22168L18.1406 12.4404L12 16.0967L5.8125 12.4404"
                    fill="#343434"
                  />
                  <path
                    d="M12 2.22168V9.62793L5.8125 12.4404M5.8125 13.6123L12 17.2686V22.2842"
                    fill="#8C8C8C"
                  />
                  <path
                    d="M12 9.62793V16.0967L18.1406 12.4404"
                    fill="#141414"
                  />
                  <path d="M5.8125 12.4404L12 9.62793V16.0967" fill="#393939" />
                </svg>
              </div>
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 8.2998H15M15 8.2998L8 1.2998M15 8.2998L8 15.2998"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="icon">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1_16957)">
                    <path
                      d="M9.9996 26.9642C15.7396 30.2781 23.0792 28.3115 26.3932 22.5716C29.7072 16.8317 27.7405 9.49207 22.0006 6.17814C16.2606 2.86421 8.92092 4.83085 5.60694 10.5708C2.29297 16.3107 4.25963 23.6502 9.9996 26.9642Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.8323 28.3712C15.2803 28.6352 16.7523 28.6272 18.1683 28.3632V25.7392H13.8323V28.3712ZM20.4963 22.3632L20.8323 22.9392C20.2963 23.3472 19.7123 23.6832 19.0963 23.9392L18.7603 23.3552C19.3763 23.1072 19.9603 22.7712 20.4963 22.3632ZM17.0003 23.8272V24.4992C16.3443 24.5872 15.6723 24.5872 15.0003 24.5072V23.8352C15.6723 23.9232 16.3443 23.9232 17.0003 23.8272ZM11.1683 22.9472L11.5043 22.3632C11.7603 22.5632 12.0403 22.7552 12.3363 22.9232C12.6243 23.0912 12.9283 23.2352 13.2323 23.3632L12.8963 23.9472C12.5923 23.8192 12.2963 23.6672 12.0003 23.4992C11.7043 23.3312 11.4323 23.1472 11.1683 22.9472ZM4.70429 20.5872L6.97629 19.2752L9.14429 23.0272L6.86429 24.3472C5.91229 23.2272 5.19229 21.9472 4.70429 20.5872ZM22.7923 19.3392L23.3763 19.6752C23.2483 19.9792 23.0963 20.2752 22.9283 20.5712C22.7603 20.8672 22.5763 21.1392 22.3763 21.4032L21.7923 21.0672C21.9923 20.8112 22.1843 20.5312 22.3523 20.2352C22.5203 19.9472 22.6643 19.6432 22.7923 19.3392ZM9.62429 11.7392L10.2083 12.0752C10.0083 12.3312 9.81629 12.6112 9.64829 12.9072C9.48029 13.1952 9.33629 13.4992 9.20829 13.8032L8.62429 13.4672C8.75229 13.1632 8.90429 12.8672 9.07229 12.5712C9.24029 12.2752 9.42429 12.0032 9.62429 11.7392ZM12.9043 9.20319L13.2403 9.78719C12.6243 10.0352 12.0403 10.3712 11.5043 10.7792L11.1683 10.2032C11.7043 9.79519 12.2883 9.45919 12.9043 9.20319ZM17.0003 8.63519V9.30719C16.3283 9.21919 15.6563 9.21919 15.0003 9.31519V8.64319C15.6643 8.55519 16.3283 8.55519 17.0003 8.63519ZM18.7683 9.77919L19.1043 9.19519C19.4083 9.32319 19.7043 9.47519 20.0003 9.64319C20.2963 9.81119 20.5683 9.99519 20.8323 10.1952L20.4963 10.7792C20.2403 10.5792 19.9603 10.3872 19.6643 10.2192C19.3763 10.0512 19.0723 9.90719 18.7683 9.77919ZM23.2563 15.5712H23.9283C24.0163 16.2352 24.0163 16.8992 23.9363 17.5712H23.2643C23.3523 16.9072 23.3523 16.2272 23.2563 15.5712ZM8.06429 15.5712H8.73629C8.64829 16.2432 8.64829 16.9152 8.74429 17.5712H8.07229C7.98429 16.9152 7.98429 16.2432 8.06429 15.5712ZM21.7923 12.0752L22.3683 11.7392C22.7763 12.2752 23.1123 12.8592 23.3683 13.4752L22.7843 13.8112C22.5363 13.1952 22.2003 12.6112 21.7923 12.0752ZM8.63229 19.6672L9.21629 19.3312C9.46429 19.9472 9.80029 20.5312 10.2083 21.0672L9.63229 21.4032C9.22429 20.8672 8.88829 20.2832 8.63229 19.6672ZM27.2963 12.5552C26.8083 11.1952 26.0883 9.91519 25.1363 8.79519L22.8563 10.1152L25.0243 13.8672L27.2963 12.5552ZM18.1683 4.77119V7.40319H13.8323V4.77919C15.2563 4.51519 16.7203 4.50719 18.1683 4.77119ZM6.86429 8.79519L9.14429 10.1152L6.97629 13.8672L4.69629 12.5472C4.93629 11.8752 5.24029 11.2112 5.60829 10.5712C5.97629 9.93119 6.40029 9.33919 6.86429 8.79519ZM25.1363 24.3472C25.6003 23.8032 26.0243 23.2112 26.3923 22.5712C26.7603 21.9312 27.0643 21.2672 27.3043 20.5952L25.0243 19.2752L22.8563 23.0272L25.1363 24.3472Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_16957">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.571289)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div className="earth">
              <div className="loader">
                <p>Connecting</p>
                <div>
                  <span className="bar1"></span>
                  <span className="bar2"></span>
                  <span className="bar3"></span>
                </div>
              </div>
              <img src={earth} alt="earth" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product;
